module.exports = __webpack_public_path__ + "static/WEDDING E&M-233-1bda38530eacf5f927ab29e017366275.jpg";